<template>
    <div>
        <div v-if="paginator && items.length">
            <!-- Table -->
            <div class="row" style="margin-top: 50px;">
                <div class="col-md-12">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th v-for="(column, code) in columns">
                                    {{ column }}
                                    <i v-if="hasColumnInfo(code)"
                                       class="fa fa-info-circle"
                                       :title="columnInfo(code)"/>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items">
                                <td>{{ rowNumber(index) }}.</td>
                                <td v-for="(column, code) in columns">
                                    {{ item[code] }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Pagination -->
            <div class="row" v-if="last_page !== 1">
                <div class="col-md-6 pull-right">
                    <nav class="pull-right">
                        <ul class="pagination">
                            <li v-if="current_page && current_page !== 1">
                                <a aria-label="Prev"
                                   @click.prevent.self="paginate(current_page - 1)"
                                >
                                    <span aria-hidden="true">&larr;</span>
                                    {{ translations.pagination_prev }}
                                </a>
                            </li>
                            <li v-for="number in last_page"
                                :class="{active: current_page === number}"
                                v-if="(number - current_page) < 5 && (current_page - number) < 5"
                            >
                                <a href="#" @click.prevent.self="paginate(number)">
                                    {{ number }}
                                </a>
                            </li>
                            <li v-if="current_page !== last_page">
                                <a aria-label="Next"
                                   @click.prevent.self="paginate(current_page + 1)"
                                >
                                    {{ translations.pagination_next }}
                                    <span aria-hidden="true">&rarr;</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <div class="col-md-12" v-if="paginator && !items.length">
            <h3>{{ translations.empty_result }}</h3>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['columns', 'columns_info', 'paginator', 'translations'],
        computed: {
            items() {
                return this.paginator.data;
            },
            current_page() {
                return this.paginator.current_page;
            },
            last_page() {
                return this.paginator.last_page;
            }
        },
        methods: {
            paginate(number) {
                this.$emit('update-page', number);
            },
            rowNumber(index) {
                return this.paginator.from + index;
            },
            hasColumnInfo(code) {
                if (!this.columns_info) {
                    return false;
                }

                return code in this.columns_info;
            },
            columnInfo(code) {
                if (!this.hasColumnInfo(code)) {
                    return null;
                }

                return this.columns_info[code];
            }
        },
    };
</script>
